import { Component, OnInit } from '@angular/core';
import { LibraryService } from 'src/app/services/Library/library.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';

@Component({
  selector: 'app-book-fine-collection',
  templateUrl: './book-fine-collection.component.html',
  styleUrls: ['./book-fine-collection.component.css']
})
export class BookFineCollectionComponent implements OnInit {
  PersonTypeList=[];
  Submitted:boolean=false;
  BookFineCollectionList=[];
  BookFineList=[];
  BookGroup=[];
  BookList=[];
  AuthorList=[];
  PublicationList=[];
  currentPage=0;
  pagedItems=[];
  constructor(private  libraryservice: LibraryService,private lookupservice: LookupService, public globalHelper: GlobalHelper, 
    private spinnerService: Ng4LoadingSpinnerService) { }

    
    SearchModel = {
      FromDate: '',
      ToDate: '',
      IsStaff: 0,
      IsStudent: 0,
      BookTitleID: 0,
      BookGroupID: 0,
      PersonTypeID: 0,
      AuthorID: 0,
      Medium: 0,
      PublicationID: 0,
      LibCardNo: '',
  };

  GetPersonType  () {
      this.lookupservice.GetLookupsList('PersonType', '').subscribe( (data:any)=> {
          this.PersonTypeList = data.LookupItems;
      });
  };
  BookISBNModel={
    BookTitleID:0,
    BookGroupID:0,
    AuthorID:0,
    PublicationID:0,
  }

  Clear  () {

      this.BookISBNModel.BookTitleID = 0;
      this.BookISBNModel.BookGroupID = 0;
      this.BookISBNModel.AuthorID = 0;
      this.BookISBNModel.PublicationID = 0;
  }


  GetBookFineCollection  () {
    this.spinnerService.show();
      this.libraryservice.GetBookFineCollection(JSON.stringify(this.SearchModel)).subscribe( (response:any)=> {
        
          this.BookFineCollectionList = response.BookFineCollectionList;
          this.search(this.BookFineCollectionList);
          this.globalHelper.CheckActionStatus(response);               
          this.spinnerService.hide();
      });
  };
  TotalPaidAmount=0;
  TotalFineAmount=0;
  TotalDiscount=0;
  GetFineDetails  (item) {
      this.libraryservice.GetFineDetails(item.BookFineID).subscribe( (response:any)=> {

          this.BookFineList = response.BookFineList;
          var TotalFineAmount = 0;
          var TotalDiscount = 0;
          var TotalPaidAmount = 0;

          for (var i = 0; i < this.BookFineList.length; i++) {

              TotalFineAmount = (TotalFineAmount) + parseFloat(this.BookFineList[i].FineAmount)
              TotalDiscount = (TotalDiscount) + parseFloat(this.BookFineList[i].Discount)
              TotalPaidAmount = (TotalPaidAmount) + parseFloat(this.BookFineList[i].PaidAmount)

          }
          this.globalHelper.CheckActionStatus(response);
          this.TotalFineAmount = TotalFineAmount;
          this.TotalDiscount = TotalDiscount;
          this.TotalPaidAmount = TotalPaidAmount;
      });
  }
 

  GetAllBookGroup  () {
      this.lookupservice.GetLookupsList('BookGroup', '').subscribe( (data:any)=> {
          this.BookGroup = data.LookupItems;
      });
  };

  GetAllBookTitle  () {

    this.lookupservice.GetLookupsList('BookTitle', '').subscribe( (data:any)=> {

          this.BookList = data.BookList;

      });
  };

  GetAllAuthor  () {

    this.lookupservice.GetLookupsList('Author', '').subscribe( (data:any)=> {

          this.AuthorList = data.AuthorList;

      });
  };

  GetAllPublication  () {

      this.lookupservice.GetLookupsList('Publication', '').subscribe( (data:any)=> {

          this.PublicationList = data.PublicationList;



      });
  };

  sortingOrder=0;
  groupedItems=[];
  itemsPerPage=40;
  query='';


  PagingInit  () {
      this.sortingOrder = 0;

      this.groupedItems = [];
      this.itemsPerPage = 40;
      this.currentPage = 0;
      this.query = '';
    
  }

  //var searchMatch = function (haystack, needle) {
  //    if (haystack == null && needle != '')
  //        return false;

  //    if (!needle) {
  //        return true;
  //    }
  //    return haystack.toString().toLowerCase().indexOf(needle.toString().toLowerCase()) !== -1;
  //};
  // calculate page in place
  groupToPages  (searchList) {
      this.pagedItems = [];
      for (var i = 0; i < searchList.length; i++) {
          if (i % this.itemsPerPage === 0) {
              this.pagedItems[Math.floor(i / this.itemsPerPage)] = [searchList[i]];
          } else {
              this.pagedItems[Math.floor(i / this.itemsPerPage)].push(searchList[i]);
          }
      }

  };

  range  (start, end) {
      var ret = [];
      if (!end) {
          end = start;
          start = 0;
      }
      for (var i = start; i < end; i++) {
          ret.push(i);
      }
      return ret;

  };

  prevPage  () {
      if (this.currentPage > 0) {
          this.currentPage--;
      }
  };

  nextPage  () {
      if (this.currentPage < this.pagedItems.length - 1) {
          this.currentPage++;
      }
  };

  

  search  (searchList) {

      //$scope.filteredItems = $filter('filter')(searchList, function (item) {

      //    for (var attr in item) {
      //        if (searchMatch(item[attr], $scope.query))
      //            return true;
      //    }
      //    return false;
      //});

      this.groupToPages(searchList);
      this.currentPage = 0;

  };
  CancelRemarks='';
  ReceiptNo='';
  hidePrint = false;
  SetCancel  (item) {
      this.ReceiptNo = item.ReceiptNo;

  }

  GetCancelBookFine  () {
      this.libraryservice.GetCancelBookFine(this.ReceiptNo, this.CancelRemarks).subscribe( (response:any)=> {
          // $('#academic1').click();
          this.globalHelper.CheckActionStatus(response);
          this.GetBookFineCollection();
      });
  }


  PrintFineReceipt  (BookFineID, PrintType, CopyType, Cancel) {
      this.hidePrint = false;

      if (Cancel == 'Y') {
          let CopyType = 'C';
      }
      var url = "../../../../App/Library/BookFineReceiptPrint/BookFineReceiptPrint.html?PrintType=FineReceipt&ReceiptNo=" + BookFineID + "&PrintType=" + PrintType + "&CopyType=" + CopyType;
      this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
  };


  Print  () {

      // window.print();

      var divContents = document.getElementById("dvContainer").innerHTML;
      divContents = divContents.replace('no record found', '');
      var printWindow = window.open('', '', 'height=400,width=800');
      printWindow.document.write('<html><head><title>Student Marks Summary</title>');
      printWindow.document.write('<style type="text/css">');
      printWindow.document.write('.t1{ border-top: 1px solid black;  border-left: 1px solid black;white-space:nowrap;font-family:Calibri;font-size:10px} .t2 { border-right: 1px solid black; border-bottom: 1px solid black;}.t3 { border-right: 1px solid black;border-bottom: 1px solid black; }');
      printWindow.document.write('</style>');
      printWindow.document.write('</head><body >');
      printWindow.document.write(divContents);
      printWindow.document.write('</body></html>');
      printWindow.document.close();
      printWindow.print();
  }
 

  ngOnInit() {
    this.PagingInit();
    this.GetPersonType();
  }

}
